import request from '@teetsh/app/src/utils/request';
import { useState } from 'react';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

interface Props {
  file: any;
  onStart: () => void;
  onFinished: () => void;
  schoolyearId: string;
  schoolId: string;
}

export default async function uploadAttachment(props: Props) {
  const { file, onStart, onFinished, schoolyearId, schoolId } = props;

  onStart();

  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/eleves/upload`;
  const formData = new FormData();
  formData.append('file', file);
  const res = await request(requestURL, {
    method: 'POST',
    body: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  onFinished();
  return res;
}

export function useUploadElevePhoto() {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const { schoolyear, school } = useSchoolSchoolyear();
  const upload = ({ file }: { file: any }) =>
    uploadAttachment({
      file,
      onStart: () => setIsUploading(true),
      onFinished: () => setIsUploading(false),
      schoolyearId: schoolyear.id,
      schoolId: school.id,
    });

  return {
    upload,
    isUploading,
  };
}
